import * as types from '../../action-types';
import { getFlexOffer as initialState } from "../../initialState";

const getFlexOffer = (state=initialState, action) => {
  switch (action.type) {
    case types.GET_FLEX_OFFER_START:
      return {
        ...state,
        isLoading: true
      };
    case types.GET_FLEX_OFFER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.GET_FLEX_OFFER_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.GET_FLEX_OFFER_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default getFlexOffer;
